import { useQuery } from '@tanstack/react-query';

// helper
import { BaseError } from '../../helpers/BaseError';

import { FormulaCategory } from '../../models/formula.model';
// models
import { LabelWithVariantsModel } from '../../models/label.model';

// services
import API from '../../services/api';

import labelKeys from './_queryKeys';

const getLabelsAndVariants = async (
    componentTypeId: string,
    formulaCategory?: FormulaCategory,
): Promise<LabelWithVariantsModel[]> => {
    const { data } = await API.getLabelsAndVariantsV1(
        componentTypeId,
        formulaCategory,
    );

    return data;
};

export default function useLabelsVariantsQuery(
    componentTypeId: string,
    formulaCategory?: FormulaCategory,
) {
    return useQuery<LabelWithVariantsModel[], BaseError>({
        queryKey: labelKeys.labelsVariantsV1(componentTypeId, formulaCategory),
        queryFn: () => getLabelsAndVariants(componentTypeId, formulaCategory),
        enabled: !!componentTypeId,
    });
}
